(function() {
  function initAbSgeFaq(scope) {
    var root = scope || document;
    var container = root.querySelector('.ab-sge-container');
    if (!container) return;

    var items = container.querySelectorAll('.ab-sge-paa-item');
    items.forEach(function(item) {
      var q = item.querySelector('.ab-sge-paa-question');
      if (!q) return;
      q.addEventListener('click', function() {
        var isActive = item.classList.contains('active');
        items.forEach(function(i){ i.classList.remove('active'); });
        if (!isActive) item.classList.add('active');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function(){ initAbSgeFaq(document); });
  document.addEventListener('shopify:section:load', function(e){ initAbSgeFaq(e.target); });
})();
